export const init = () => {
  $('.slider').slick({
    dots: true,
    infinite: false,
    arrows: true,
    prevArrow: $('.prev'),
    nextArrow: $('.next'),
  });
  $('.slider-mobile').slick({
    arrows: true,
    dots: false,
    infinite: false,
    prevArrow: $('.prev-mobile'),
    nextArrow: $('.next-mobile'),
    asNavFor: '.slider-nav',
  });
  $('.slider-nav').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: false,
    asNavFor: '.slider-mobile',
    dots: false,
    arrows: false,
    centerMode: false,
    focusOnSelect: true,
  });
  $('.modal__slider').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: false,
    dots: false,
    arrows: true,
    centerMode: false,
    prevArrow: $('.modal-prev'),
    nextArrow: $('.modal-next'),
    responsive: [
      {
        breakpoint: 768,
        settings: 'unslick',
      },
    ],
  });
  $('.carousel-row__slider').each(function (idx, item) {
    var carouselId = "carousel" + idx;
    this.id = carouselId;
    var prevArrowSelect = $(this).prev().find('.carousel-row_prev');
    var nextArrowSelect = $(this).prev().find('.carousel-row_next');
    $(this).slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: false,
        dots: false,
        arrows: true,
        appendArrows: "#" + carouselId + " .prev_next",
        prevArrow: prevArrowSelect,
        nextArrow: nextArrowSelect,
        centerMode: false,
        responsive: [
          {
            breakpoint: 768,
            settings: 'unslick',
          },
        ]
    });
 });
};


